import { IImage, IStrapiImage } from "@/api/dtos/shared-component.type";
import { env } from "@env";

export const getImageUrl = (obj: IImage | undefined) => {
  return obj?.image?.data?.attributes?.url
    ? env.NEXT_PUBLIC_MEDIA_URL + obj?.image?.data?.attributes?.url
    : "";
};

export const getVideoUrl = (obj: IStrapiImage | undefined) => {
  return obj?.data?.attributes?.url
    ? env.NEXT_PUBLIC_MEDIA_URL + obj?.data?.attributes?.url
    : "";
};
